import React from "react";
import { Button } from "antd";
import { SubtitleRequestState } from "providers/AudioProvider/useSubtitleRequest";
import { useUiLang } from "utils/uiLanguage";

/**
 * Загрузка и сбой субтитров папки.
 *
 * Первая загрузка (ленты на экране ещё нет) — строкой на месте ленты. Перечитывание показанной ленты (после ♪,
 * выкладки, починки — `hasData`) — плашкой ПОВЕРХ ленты, без места в потоке страницы: строкой она сдвигала ленту
 * на ≈36 px, и следующий клик по прежнему месту попадал мимо (проба P50m30d, правка E6 — ♪ у реплики лектора).
 * Плашка загрузки клики пропускает насквозь; у плашки сбоя нажимается только «Повторить».
 */
export function SubtitleLoadStatus({ request, onRetry }: { request: SubtitleRequestState; onRetry: () => void }) {
    const en = useUiLang() === "en";
    if (request.status === "success") return null;
    const role = request.status === "error" ? "alert" : "status";
    const content = request.status === "loading" ? (en ? "Loading subtitles…" : "Загрузка субтитров…") : <>
        <span>{en ? "Could not load subtitles." : "Не удалось загрузить субтитры."} {request.error}</span>{" "}
        <Button size="small" onClick={onRetry}>{en ? "Retry" : "Повторить"}</Button>
    </>;
    if (!request.hasData) return <div role={role} style={{ padding: "12px 20px" }}>{content}</div>;
    return <div data-testid="subtitle-load-overlay" style={{ position: "relative", height: 0, flex: "none", zIndex: 900 }}>
        <div role={role} style={{
            position: "absolute", top: 4, right: 16, maxWidth: "calc(100% - 32px)",
            padding: "2px 10px", borderRadius: 12, fontSize: 13, lineHeight: "22px",
            background: request.status === "error" ? "rgba(168, 7, 26, 0.92)" : "rgba(0, 0, 0, 0.7)", color: "#fff",
            boxShadow: "0 1px 4px rgba(0, 0, 0, 0.25)",
            pointerEvents: request.status === "loading" ? "none" : "auto",
        }}>{content}</div>
    </div>;
}
